export interface HistoricalMsiSummary {
  msiPaid: number;
  monthsRemaining: number;
  monthlyAmount: number;
  remainingBalance: number;
  nextInstallment: number | null;
}

function roundMoney(value: number): number {
  return Math.round((value + Number.EPSILON) * 100) / 100;
}

/**
 * Traduce una respuesta cotidiana como “voy en la 3 de 12” al progreso que
 * usa el dominio. La pregunta separada sobre si la mensualidad actual ya fue
 * pagada evita asumir si “voy en la 3” significa dos o tres pagos cubiertos.
 */
export function summarizeHistoricalMsi(
  totalAmount: number,
  msiMonths: number,
  currentInstallment: number,
  currentInstallmentPaid: boolean,
): HistoricalMsiSummary {
  const months = Math.max(1, Math.floor(msiMonths));
  const current = Math.min(months, Math.max(1, Math.floor(currentInstallment)));
  const msiPaid = Math.min(months, currentInstallmentPaid ? current : current - 1);
  const monthsRemaining = months - msiPaid;
  const monthlyAmount = totalAmount > 0 ? totalAmount / months : 0;

  return {
    msiPaid,
    monthsRemaining,
    monthlyAmount,
    remainingBalance: roundMoney(monthlyAmount * monthsRemaining),
    nextInstallment: monthsRemaining > 0 ? msiPaid + 1 : null,
  };
}
